import { defaultBusinessInsightsContextValue } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/context/insightsDefaultValue';
import { BusinessInsightsContextValue } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/types/businessInsightsContext';
import {
  InsightReportsResponse,
  InsightsDashboardReport,
} from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/types/InsightsDashboard';

export const mergeReportData = (
  initialReportData: InsightsDashboardReport | null,
  filteredReportData: InsightsDashboardReport | null
): Omit<
  BusinessInsightsContextValue,
  'applyFilters' | 'isLoading' | 'isError'
> => {
  return {
    ...defaultBusinessInsightsContextValue,
    ...(initialReportData || {}),
    ...(filteredReportData || {}),
  };
};

export const getRelevantInsightReport = (
  insightReports: InsightReportsResponse
): InsightsDashboardReport | null => {
  if (!insightReports?.reports?.length) {
    return null;
  }

  // Business Admin Insights supports only one report by design
  return insightReports.reports[0];
};
